/**
 * Click & collect: dropdown toggle (click for touch/accessibility, hover still works via CSS)
 */
export const clickCollectDropdown = () => {
	const dropdowns = document.querySelectorAll('.click-collect__dropdown');

	dropdowns.forEach((dropdown) => {
		const button = dropdown.querySelector('.click-collect__dropdown-button');
		if (!button) return;

		button.addEventListener('click', (e) => {
			e.preventDefault();
			const isOpen = dropdown.classList.toggle('is-open');
			// Close other open dropdowns
			dropdowns.forEach((d) => {
				if (d !== dropdown) d.classList.remove('is-open');
			});
		});
	});

	// Close on click outside
	document.addEventListener('click', (e) => {
		if (e.target.closest('.click-collect__dropdown')) return;
		dropdowns.forEach((d) => d.classList.remove('is-open'));
	});
};
